import Header from '@/pages/home/components/Header';
import Hero from '@/pages/home/components/Hero';
import CommentsSection from '@/pages/home/components/CommentsSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import MediaSection from '@/pages/home/components/MediaSection';
import RankingSection from '@/pages/home/components/RankingSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import AboutSection from '@/pages/home/components/AboutSection';
import AppSection from '@/pages/home/components/AppSection';
import ContactSection from '@/pages/home/components/ContactSection';
import IndexSection from '@/pages/home/components/IndexSection';
import FaqSection from '@/pages/home/components/FaqSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import CardsSection from '@/pages/home/components/CardsSection';
import CarouselSection from '@/pages/home/components/CarouselSection';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <CommentsSection />
        <FeaturesSection />
        <MediaSection />
        <RankingSection />
        <UpdatesSection />
        <AboutSection />
        <AppSection />
        <ContactSection />
        <IndexSection />
        <FaqSection />
        <TopicsSection />
        <CardsSection />
        <CarouselSection />
      </main>
      <Footer />
    </>
  );
}